///  TODO добавить хранилище с ttl
import HttpClient from '@/api/calls'
import store from '@/store'
const cache = {
  listCity: []
}
const get = function () {
  if (cache.listCity.length === 0) {
    return HttpClient.httpGet('dictionaries.cities', {filters: {iso2: store.getters.regionUser}}).then(response => {
      cache.listCity = response.data
      return response.data
    })
  } else {
    return new Promise(function (resolve, reject) {
      resolve(cache.listCity)
    })
  }
}
export default {
  get
}



// WEBPACK FOOTER //
// ./src/cahces/cities.js